import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: {
      country: '',
      emailInfo: {
        address: '',
        validated: false
      },
      wallet: {
        currency: 23,
        balance: 0,
        hasWallet: true
      },
      name: '',
      steamId: ''
    },
    login: false,
    currency: 'CNY',
    currencyOptions:{

    }
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    setCurrency(state, currency) {
      state.currency = currency
    },
    setLogin(state, login) {
      state.login = login
    },
    clearUserInfo(state) {
      state.userInfo = {
        country: '',
        emailInfo: {
          address: '',
          validated: false
        },
        wallet: {
          currency: 23,
          balance: 0,
          hasWallet: true
        },
        name: '',
        steamId: ''
      }
      state.login = false
    },
    setCurrencyOptions(state,currencyOptions){
      state.currencyOptions = currencyOptions
    }
  },
  getters: {
    getCurrency: state => {
      return state.currency
    },
    getUserInfo: state => {
      return state.userInfo
    },
    getLogin: state => {
      return state.login
    },
    getCurrencyOptions: state => {
      return state.currencyOptions
    }
  }
  // 可以在此定义其他模块、getters等
});

export default store



// WEBPACK FOOTER //
// ./src/store/index.js